export default {
	data(){
		return {
			currentView: 1,
			allKeywords: [],
			totalViews: undefined,
			keywordsView: []
		}
	},

	computed:{
		keywordsPerView: {
			get() {
				return this.keywordsView
			},
			set(keywords) {
				this.keywordsView = keywords
			}
		},

		multiViewsBtnStatus(){
			return this.allKeywords.length > 1;
		}
	},

	methods: {
		move(direction) {
			if (direction === 'forward') {
				this.currentView = this.currentView < this.allKeywords.length ? this.currentView+=1 : 1;
				if(this.allKeywords[this.currentView-1]) this.keywordsPerView = this.allKeywords[this.currentView-1];
			}else{
				this.currentView = this.currentView-1===0 ? 1 : this.currentView-1;
				if(this.allKeywords[this.currentView-1]) this.keywordsPerView = this.allKeywords[this.currentView-1];
			}
		},
	},
}
